import { z } from 'zod';
/** Sanitized session info — never includes the raw token or token hash. */
export const SessionSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    expiresAt: z.string().datetime(),
    lastUsedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=session.schema.js.map